import { createFileRoute } from '@tanstack/react-router'
import { CreateContractPage } from '../../../components/CreateContractPage'

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const Route = createFileRoute('/$org/contracts/create')({
  component: CreateContract,
  validateSearch: (search: Record<string, unknown>): { asset_uid?: string; contract_type_uid?: string } => ({
    asset_uid: search.asset_uid as string | undefined,
    // Prefilled from the contract checklist's « Saisir à la main » (spec 2026-10-11-17).
    contract_type_uid: typeof search.contract_type_uid === 'string' && UUID.test(search.contract_type_uid)
      ? search.contract_type_uid
      : undefined,
  }),
})

function CreateContract() {
  const { asset_uid, contract_type_uid } = Route.useSearch()
  return <CreateContractPage preselectedAssetUid={asset_uid} preselectedContractTypeUid={contract_type_uid} />
}
